export default "__VITE_PUBLIC_ASSET__4923afb8__"